import React, { useCallback, useEffect, useState, useMemo } from 'react';

import { Container, Content, AlteredHeader } from 'styles/sgo_wrappers';

import SGOHeader from 'components/SGOHeader';
import SGONavbar from 'components/SGONavbar';
import ScrollTop from 'components/ScrollTop';
import SGOFooter from 'components/SGOFooter';
import Loading from 'components/Loading';
import IncludeButton from 'components/IncludeButton';

import { useCredentials } from 'hooks/credentials';
import { useAuth } from 'hooks/auth';
// import { useChanges } from 'hooks/changes';
import api from 'services/api';
import { parseISO, isBefore } from 'date-fns';

import {
  getLocalStorage,
  localStorageLength,
  setLocalStorage,
} from 'utils/handleLocalStorage';

import { formatNumber } from 'utils/calcTotal';

import { formatDate, generateTodayV2, stringToDate } from 'utils/formatDate';
import { useSpring } from 'react-spring';
import { useWindow } from 'hooks/window';
import { FaMobileAlt, FaPencilAlt, FaTimes } from 'react-icons/fa';
import { Link, useLocation } from 'react-router-dom';

import * as D from 'styles/dialog_delete';
import { DeleteProps, ModalDeleteContent } from 'styles/dialog_delete';

import { useToast } from 'hooks/toast';
import {
  FilterContainer,
  LeftSVG,
  RightSVG,
  RotateMessage,
  ContentContainer,
  ContentHeader,
  Contents,
  Data,
  Lanc,
  Compl,
  Mov,
  Saldo,
  Wrapper,
  IncludeNew,
  PreviousBalance,
  Balance,
  UpdateReg,
  ExcReg,
} from './styles';
import { monthList, MonthListProps } from '../../monthList';

export interface ListProps {
  date: string;
  lanc: string;
  landesc: string;
  compl: string;
  value: number;
  type: string;
  seq: number;
  auto: string;
  month: number;
  year: number;
  allowModify: boolean;
}

export interface LocalStorageProps {
  ano?: number;
  mes?: number;
  anb?: string;
  anbdesc?: string;
  anbg?: string;
  anbgdesc?: string;
  loc?: string;
  locdesc?: string;
  app?: string;
}

export interface CoordProps {
  cod: string;
  desc: string;
}

const Aplic: React.FC = () => {
  // const { currDate } = useChanges();
  const location = useLocation();
  const { width } = useWindow();
  const { user } = useAuth();
  const { addToast } = useToast();
  const { errorHandling, handlePermission } = useCredentials();
  const [loading, setLoading] = useState(true);
  const [app] = useState(
    location.pathname.replace('/sgo/tesouraria/appl/', ''),
  );
  const [appdesc, setAppdesc] = useState('');

  const [deleteDiag, setDeleteDiag] = useState<DeleteProps>({
    open: false,
    content: '',
    values: {},
  });

  const [coordSelected] = useState(() => {
    const { anb, anbdesc, loc, locdesc }: LocalStorageProps = getLocalStorage(
      `${process.env.REACT_APP_APLIC}`,
    );

    if (anb && loc) {
      return { cod: loc, desc: locdesc };
    }
    if (anb && !loc) {
      return { cod: anb, desc: anbdesc };
    }
    if (!anb && loc) {
      return { cod: loc, desc: locdesc };
    }
    return {} as CoordProps;
  });

  const [year, setYear] = useState(() => {
    const hasItem = localStorageLength(`${process.env.REACT_APP_APLIC}`);

    if (hasItem > 0) {
      const { ano }: LocalStorageProps = getLocalStorage(
        `${process.env.REACT_APP_APLIC}`,
      );

      if (ano) {
        return ano;
      }
    }
    return new Date(parseISO(new Date().toISOString())).getUTCFullYear();
  });

  const [month, setMonth] = useState<MonthListProps>(() => {
    const hasItem = localStorageLength(`${process.env.REACT_APP_APLIC}`);

    if (hasItem > 0) {
      const { mes }: LocalStorageProps = getLocalStorage(
        `${process.env.REACT_APP_APLIC}`,
      );

      if (mes) {
        return {
          value: mes,
          label:
            monthList[
              monthList.findIndex((item: MonthListProps) => item.value === mes)
            ].label,
        };
      }
    }
    const monthNow =
      new Date(parseISO(new Date().toISOString())).getUTCMonth() + 1;
    return {
      value: monthNow,
      label:
        monthList[
          monthList.findIndex((item: MonthListProps) => item.value === monthNow)
        ].label,
    };
  });

  const [lastDay, setLastDay] = useState(new Date().toISOString());
  const [list, setList] = useState<ListProps[]>([]);
  const [rawList, setRawList] = useState<ListProps[]>([]);

  const handleLastDay = useCallback(() => {
    const { ano, mes }: LocalStorageProps = getLocalStorage(
      `${process.env.REACT_APP_APLIC}`,
    );

    const yearForList =
      ano || new Date(parseISO(new Date().toISOString())).getUTCFullYear();
    const monthForList =
      mes || new Date(parseISO(new Date().toISOString())).getUTCMonth() + 1;

    const last = new Date(yearForList, monthForList, 0);
    const today = new Date();

    const monthForLast = today.getUTCMonth() + 1;

    setLastDay(
      isBefore(last, today) || monthForLast !== monthForList
        ? last.toISOString()
        : today.toISOString(),
    );
  }, []);

  const getList = useCallback(
    async (params?: string) => {
      try {
        setLoading(true);
        handleLastDay();

        const { anb, loc }: LocalStorageProps = getLocalStorage(
          `${process.env.REACT_APP_APLIC}`,
        );

        let coord = '';
        if (anb && loc) {
          coord = loc;
        } else if (anb && !loc) {
          coord = anb;
        } else if (!anb && loc) {
          coord = loc;
        } else {
          coord = '';
        }

        const response = await api.get(
          `/sgo/aplic_list.php?data=${JSON.stringify({
            code: params || coord,
            uuid: app,
          })}`,
        );

        const currentRecords = response.data.fetchList.map((item: any) => {
          const current = stringToDate(item.date);
          return {
            ...item,
            allowModify:
              item.auto !== 'A' &&
              current.getMonth() >= 0 &&
              current.getFullYear() >= generateTodayV2().getFullYear(),
          };
        });

        setRawList(currentRecords);
        setAppdesc(response.data.appdesc);

        const { ano, mes }: LocalStorageProps = getLocalStorage(
          `${process.env.REACT_APP_APLIC}`,
        );

        const yearForList =
          ano || new Date(parseISO(new Date().toISOString())).getUTCFullYear();
        const monthForList =
          mes || new Date(parseISO(new Date().toISOString())).getUTCMonth() + 1;

        setList(
          currentRecords.filter(
            (item: ListProps) =>
              item.month === monthForList && item.year === yearForList,
          ),
        );

        setLoading(false);
      } catch (err) {
        errorHandling(err);
      }
    },
    [handleLastDay, app, errorHandling],
  );

  useEffect(() => {
    setLocalStorage(`${process.env.REACT_APP_APLIC}`, { app });
    handlePermission(['GUI', 'LOC']);

    getList();
  }, [app, getList, handlePermission, user.perfil]);

  const handleLessMonth = useCallback(() => {
    const newMonth = month.value - 1;
    const index = monthList.findIndex(
      (item: MonthListProps) => item.value === newMonth,
    );

    setMonth({
      value: newMonth === 0 ? 12 : newMonth,
      label: index < 0 ? 'Dezembro' : monthList[index].label,
    });

    setYear(newMonth === 0 ? year - 1 : year);

    setLocalStorage(
      `${process.env.REACT_APP_APLIC}`,
      newMonth === 0
        ? {
            mes: 12,
            ano: year - 1,
          }
        : { mes: newMonth, ano: year },
    );

    handleLastDay();
    setList(
      rawList.filter((item: ListProps) =>
        newMonth === 0
          ? item.year === year - 1 && item.month === 12
          : item.year === year && item.month === newMonth,
      ),
    );
  }, [handleLastDay, month.value, rawList, year]);

  const handleMoreMonth = useCallback(() => {
    const newMonth = month.value + 1;
    const index = monthList.findIndex(
      (item: MonthListProps) => item.value === newMonth,
    );

    setMonth({
      value: newMonth === 13 ? 1 : newMonth,
      label: index < 0 ? 'Janeiro' : monthList[index].label,
    });

    setYear(newMonth === 13 ? year + 1 : year);

    setLocalStorage(
      `${process.env.REACT_APP_APLIC}`,
      newMonth === 13
        ? {
            mes: 1,
            ano: year + 1,
          }
        : { mes: newMonth, ano: year },
    );
    handleLastDay();
    setList(
      rawList.filter((item: ListProps) =>
        newMonth === 13
          ? item.year === year + 1 && item.month === 1
          : item.year === year && item.month === newMonth,
      ),
    );
  }, [handleLastDay, month.value, rawList, year]);

  const handleDeleteSetup = useCallback((ev: any) => {
    setDeleteDiag({
      open: true,
      values: { ...ev.currentTarget.dataset },
    });
  }, []);

  const handleDelete = useCallback(async () => {
    try {
      setDeleteDiag((state) => ({ ...state, open: false }));
      setLoading(true);

      if (deleteDiag.values?.seq) {
        const data = {
          seq: deleteDiag.values.seq,
        };

        const send = new FormData();
        send.append('data', JSON.stringify(data));

        await api.post('/sgo/aplic_delete.php', send, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });

        addToast({
          type: 'success',
          title: 'Sucesso!',
          description: 'Registro excluído.',
        });

        getList();
      } else {
        setLoading(false);
        addToast({
          type: 'error',
          title: 'Falha na Requisição',
          description:
            'Verifique o lançamento e caso o problema persista acione o suporte ao SGO.',
        });
      }
    } catch (err) {
      errorHandling(err);
    }
  }, [deleteDiag.values, addToast, getList, errorHandling]);

  const saldoAnterior = useMemo(() => {
    const dateNow = new Date(year, month.value - 1, 1);
    return rawList.reduce((accum, { date, value, type }: ListProps) => {
      return isBefore(new Date(parseISO(date)), dateNow)
        ? type === 'E'
          ? accum + value
          : accum - value
        : accum;
    }, 0);
  }, [month.value, rawList, year]);

  const saldoAtual = useMemo(() => {
    // return 0;
    const dateNow = new Date(year, month.value, 1);
    return rawList.reduce((accum, { date, value, type }: ListProps) => {
      return isBefore(new Date(parseISO(date)), dateNow)
        ? type === 'E'
          ? accum + value
          : accum - value
        : accum;
    }, 0);
  }, [month.value, rawList, year]);

  const monthlyEntrances = useMemo(() => {
    return list.reduce((accum, { value, type }: ListProps) => {
      return type === 'E' ? accum + value : accum;
    }, 0);
  }, [list]);

  const monthlyOutcomes = useMemo(() => {
    return list.reduce((accum, { value, type }: ListProps) => {
      return type === 'S' ? accum + value : accum;
    }, 0);
  }, [list]);

  const shrinkCompl = useSpring({
    width: width >= 790 ? '184px' : '0px',
    opacity: width >= 790 ? 1 : 0,
    height: width >= 790 ? 'auto' : 0,
    padding: width >= 790 ? '3px' : '0px',
  });

  const shrinkLanc = useSpring({
    width: width >= 640 ? '142px' : '0px',
    opacity: width >= 640 ? 1 : 0,
    height: width >= 640 ? 'auto' : 0,
    padding: width >= 640 ? '3px' : '0px',
  });

  const shrinkOptions = useSpring({
    width: width >= 475 ? '75px' : '50px',
    // opacity: width >= 460 ? 1 : 0,
    // padding: width >= 460 ? '3px' : '0px',
    // height: width >= 460 ? 'auto' : 0,
  });

  const shrinkMov = useSpring({
    width: '100px',
    // width: width >= 475 ? '100px' : '80px',
  });

  const tableHeight = useSpring({
    maxHeight: '480px',
    height: '100%',
  });

  const showMessage = useSpring({
    opacity: width >= 640 ? 0 : 1,
    height: width >= 640 ? 0 : 'auto',
  });

  const showButton = useSpring({
    opacity: width >= 720 ? 0 : 1,
    height: width >= 720 ? 0 : 'auto',
    pointerEvents: width >= 720 ? 'all' : 'none',
  });

  const prevBalance = useSpring({
    opacity: !loading ? 1 : 0,
    transform: !loading ? 'translateX(0px)' : 'translateX(20px)',
  });

  return (
    <Container>
      <Loading isLoading={loading} />
      {width >= 720 && (
        <IncludeButton path={location.pathname.replace(app, 'insert')} />
      )}
      <ScrollTop />
      <SGOHeader />
      <SGONavbar />

      <Content>
        <AlteredHeader>{appdesc}</AlteredHeader>

        <FilterContainer>
          <LeftSVG onClick={handleLessMonth} />
          <p>{month.label}</p>&nbsp;/&nbsp;<p>{year}</p>
          <RightSVG onClick={handleMoreMonth} />
        </FilterContainer>

        <RotateMessage style={showMessage}>
          <span>
            <p>Para mais informações dos lançamentos, vire seu aparelho</p>
          </span>
          <span>
            <FaMobileAlt />
          </span>
        </RotateMessage>

        <Link
          style={{ textDecoration: 'none' }}
          to={{
            pathname: location.pathname.replace(app, 'insert'),
          }}
        >
          <IncludeNew style={showButton}>
            <p>Incluir Registro</p>
          </IncludeNew>
        </Link>

        <PreviousBalance style={prevBalance}>
          <p>Saldo anterior:&nbsp;</p>
          <p
            style={
              {
                /* color: saldoAtual < 0 ? 'red' : 'green' */
              }
            }
          >
            R$&nbsp;
            <strong>{formatNumber(saldoAnterior)}</strong>
          </p>
        </PreviousBalance>
        <ContentContainer style={tableHeight}>
          <ContentHeader>
            <Data>
              <p>Data</p>
            </Data>
            <Lanc style={shrinkLanc}>
              <p>Lançamento</p>
            </Lanc>
            <Compl style={shrinkCompl}>
              <p>Complemento</p>
            </Compl>
            <Mov style={shrinkMov}>
              <p>Mov{width >= 475 ? 'imento' : '.'}</p>
            </Mov>
            <Saldo>
              <p>Saldo</p>
            </Saldo>
            <UpdateReg style={shrinkOptions}>
              {width >= 475 ? (
                <p>Editar</p>
              ) : (
                <p>
                  <FaPencilAlt />
                </p>
              )}
            </UpdateReg>
            <ExcReg style={shrinkOptions}>
              {width >= 475 ? (
                <p>Excluir</p>
              ) : (
                <p>
                  <FaTimes />
                </p>
              )}
            </ExcReg>
          </ContentHeader>
          <Contents>
            {list.length > 0 ? (
              list.map((item: ListProps, index) => (
                <Wrapper key={item.seq} $paint={index}>
                  <Data>
                    <p>{formatDate(item.date)}</p>
                  </Data>
                  <Lanc style={shrinkLanc}>
                    <p>{item.landesc}</p>
                  </Lanc>
                  <Compl style={shrinkCompl}>
                    <p>{item.compl}</p>
                  </Compl>
                  <Mov style={shrinkMov}>
                    <p
                      style={{
                        color: item.type === 'E' ? '#2156e6' : '#c53030',
                      }}
                    >
                      {`${item.type === 'E' ? '+' : '-'}${formatNumber(
                        item.value,
                      )}`}
                    </p>
                  </Mov>
                  <Saldo>
                    <p
                      style={
                        {
                          // color:
                          //   list.reduce(
                          //     (accum, { value, type }: ListProps, indexNow) => {
                          //       if (index === 0 && indexNow === 0) {
                          //         return type === 'E'
                          //           ? accum + value
                          //           : accum - value;
                          //       }
                          //       if (indexNow <= index) {
                          //         return type === 'E'
                          //           ? accum + value
                          //           : accum - value;
                          //       }
                          //       return accum;
                          //     },
                          //     saldoAnterior,
                          //   ) < 0
                          //     ? 'red'
                          //     : 'green',
                        }
                      }
                    >
                      R$&nbsp;
                      {formatNumber(
                        list.reduce(
                          (accum, { value, type }: ListProps, indexNow) => {
                            if (index === 0 && indexNow === 0) {
                              return type === 'E'
                                ? accum + value
                                : accum - value;
                            }

                            if (indexNow <= index) {
                              return type === 'E'
                                ? accum + value
                                : accum - value;
                            }
                            return accum;
                          },
                          saldoAnterior,
                        ),
                      )}
                    </p>
                  </Saldo>
                  <UpdateReg style={shrinkOptions}>
                    {!coordSelected.cod && item.allowModify ? (
                      <Link
                        to={{
                          pathname: location.pathname.replace(app, 'update'),
                          state: { reg: item },
                        }}
                      >
                        <FaPencilAlt />
                      </Link>
                    ) : (
                      <p>-</p>
                    )}
                  </UpdateReg>
                  <ExcReg style={shrinkOptions}>
                    {!coordSelected.cod && item.allowModify ? (
                      <button
                        type="button"
                        data-rawdate={item.date}
                        data-date={formatDate(item.date)}
                        data-desc={item.landesc}
                        data-rawvalue={item.value}
                        data-value={formatNumber(item.value)}
                        data-compl={item.compl}
                        data-type={item.type}
                        data-seq={item.seq}
                        onClick={handleDeleteSetup}
                      >
                        <FaTimes />
                      </button>
                    ) : (
                      <p>-</p>
                    )}
                  </ExcReg>
                </Wrapper>
              ))
            ) : (
              <Wrapper $paint={0}>
                <Data>
                  <p>{formatDate(lastDay)}</p>
                </Data>
                <Lanc style={shrinkLanc}>
                  <p style={{ padding: '3px', width: '100%' }}>-</p>
                </Lanc>
                <Compl style={shrinkCompl}>
                  <p style={{ padding: '3px', width: '100%' }}>-</p>
                </Compl>
                <Mov style={shrinkMov}>
                  <p style={{ padding: '3px', width: '100%' }}>-</p>
                </Mov>
                <Saldo>
                  <p
                    style={
                      {
                        /* color: saldoAtual < 0 ? 'red' : 'green' */
                      }
                    }
                  >
                    R$ {formatNumber(saldoAtual)}
                  </p>
                </Saldo>
                <UpdateReg style={shrinkOptions}>-</UpdateReg>
                <ExcReg style={shrinkOptions}>-</ExcReg>
              </Wrapper>
            )}
          </Contents>
        </ContentContainer>
        <Balance style={prevBalance}>
          <p>Total de Entradas:&nbsp;</p>
          <p
            style={
              {
                /* color: 'green' */
              }
            }
          >
            R$&nbsp;
            <strong>{formatNumber(monthlyEntrances)}</strong>
          </p>
        </Balance>
        <Balance style={prevBalance}>
          <p>Total de Saídas:&nbsp;</p>
          <p
            style={
              {
                /* color: 'red' */
              }
            }
          >
            R$&nbsp;
            <strong>{formatNumber(monthlyOutcomes)}</strong>
          </p>
        </Balance>

        {/* <p>Saldo Anterior: R$ {formatNumber(saldoAnterior)}</p>
        <p>Saldo Atual: R$ {formatNumber(saldoAtual)}</p>
        <p>Entradas: R$ {formatNumber(monthlyEntrances)}</p>
        <p>Saídas: R$ {formatNumber(monthlyOutcomes)}</p>
        <p>
          Batimentos Entradas: R${' '}
          {formatNumber(saldoAnterior + monthlyEntrances)}
        </p>
        <p>
          Batimentos Saídas: R$ {formatNumber(saldoAtual + monthlyOutcomes)}
        </p> */}
      </Content>
      <D.Container scroll="paper" maxWidth={false} open={deleteDiag.open}>
        <D.Title>
          <h2>*** ATENÇÃO ***</h2>
        </D.Title>
        <D.Content>
          <ModalDeleteContent>
            <p>Você está prestes a excluir o registro:</p>
            <div>
              <span>
                <p>
                  Data:&nbsp;
                  <strong>{deleteDiag.values?.date}</strong>
                </p>
              </span>
              <span>
                <p>
                  Lançamento:&nbsp;<strong>{deleteDiag.values?.desc}</strong>
                </p>
              </span>
              <span>
                <p>
                  Tipo do Movimento:&nbsp;
                  <strong>
                    {deleteDiag.values?.type === 'E' ? 'Entrada' : 'Saída'}
                  </strong>
                </p>
              </span>
              <span>
                <p>
                  Complemento:&nbsp;
                  <strong>{deleteDiag.values?.compl}</strong>
                </p>
              </span>
              <span>
                <p>
                  Valor do movimento:&nbsp;
                  <strong>R$&nbsp;{deleteDiag.values?.value}</strong>
                </p>
              </span>
            </div>

            <p>Se estiver seguro de sua decisão, clique em confirmar.</p>
          </ModalDeleteContent>
        </D.Content>
        <D.Actions>
          <D.Cancel as="button"
            type="button"
            onClick={() => setDeleteDiag({ open: false })}
          >
            Cancelar
          </D.Cancel>
          <D.Confirm as="button" type="button" onClick={handleDelete}>
            Confirmar
          </D.Confirm>
        </D.Actions>
      </D.Container>
      <SGOFooter />
    </Container>
  );
};

export default Aplic;
